/**
 * 定义所有缓存的Key，所有设置和使用缓存时，只能从当前配置中获取Key，不可在业务代码中直接将Key以字符串的形式使用
 */
export default {
  // 当前页面标题，缓存当前页面标题，用于页面刷新时，恢复页面标题展示
  PAGE_TITLE: 'PAGE_TITLE',
  // 缓存用户的语种信息，如zh/en
  CURRENT_LANGUAGE: 'CURRENT_LANGUAGE',
  // 缓存当前的主题信息，缓存主题的key值
  CURRENT_THEME: 'CURRENT_THEME',
  // 缓存后台返回的用户基本信息，只缓存用户基本信息，不缓存权限和中心信息
  CACHE_USER_INFO: 'CACHE_USER_INFO',
  // 用户登录成功保存session
  ACCESS_TOKEN: 'access_token',
  // 缓存用户拥有的菜单权限列表，数组形式，用于菜单鉴权
  USER_AUTH_MENU: 'USER_AUTH_MENU',
  // 当前用户选择的中心节点，系统中所有的中心数据需要根据该中心获取
  CURRENT_CENTER_INFO: 'CURRENT_CENTER_INFO',
  // 页面已打开菜单页签列表
  MENU_TABS_LIST: 'MENU_TABS_LIST',
  // 接口返回的菜单列表可点击
  MENU_MAP: 'MENU_MAP',
  // 缓存当前的表格条数
  CURRENT_PAGESIZE: 'CURRENT_PAGESIZE'
}
